"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Engine_1 = require("./modules/Engine");
var Parameters_1 = require("./modules/Parameters");
var EngineResults_1 = require("./EngineResults");
var BrowserHelpers_1 = require("./BrowserHelpers");
require('es6-promise').polyfill();
var BrowserEngine = (function () {
    function BrowserEngine() {
        this.params = new Parameters_1.Parameters();
    }
    Object.defineProperty(BrowserEngine, "version", {
        get: function () {
            return "4.0.0";
        },
        enumerable: true,
        configurable: true
    });
    BrowserEngine.prototype.setDefaults = function (defaults) {
        BrowserHelpers_1.BrowserHelpers.ObjectToParameters(defaults, this.params);
    };
    BrowserEngine.prototype.runSync = function (input) {
        BrowserHelpers_1.BrowserHelpers.ObjectToParameters(input, this.params);
        var engine = new Engine_1.Engine(this.params);
        var engineOutput = engine.run();
        return new EngineResults_1.EngineResults(engineOutput, this.params);
    };
    BrowserEngine.prototype.run = function (input) {
        BrowserHelpers_1.BrowserHelpers.ObjectToParameters(input, this.params);
        var engine = new Engine_1.Engine(this.params);
        var engineOutput = engine.run();
        return Promise.resolve(new EngineResults_1.EngineResults(engineOutput, this.params));
    };
    return BrowserEngine;
}());
exports.BrowserEngine = BrowserEngine;
//# sourceMappingURL=BrowserEngine.js.map